// index
window.receptIndexSet = async (mode) =>{
    const params = new URLSearchParams()
    params.append('mode',mode)
	const response = await axios.post('/recept/index',params)
	if(response.data.result==='OK')
	{
		location.href = '/recept/search'
	}
}

// search
window.receptSearchOnEnter = (e) => {
	if (e.ctrlKey || e.metaKey) {
		document.getElementById('search_sp_mode').value = 1
	}else{
		document.getElementById('search_sp_mode').value = 0
	}
	const code = document.querySelector('[name=performer_name]').value
	if(code.length===5)
	{
		const toHalf = code.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) {
			return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
		})
		document.querySelector('[name=performer_name]').value = ''
		const id = parseInt(toHalf)
		if(!isNaN(id))
		{
			location.href='/recept/edit/step1/'+id
		}
	}
}

window.receptPerformerOnfocus = () => {
	const code = document.querySelector('[name=performer_name]').value
	const toHalf = code.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) {
		return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
	})
	if(!isNaN(parseInt(toHalf)))
	{
		document.querySelector('[name=performer_name]').value = ''
	}
}

window.receptSearchPickup = async () =>{
	const params = new URLSearchParams()
	const performerName = document.querySelector('[name=performer_name]').value
	params.append('performer_name',performerName)
	const m_room_id = document.querySelector('[name=m_room_id]').value
	params.append('m_room_id',m_room_id)
	const current_day = document.querySelector('[name=current_day]').value
	params.append('current_day',current_day)
	const sp_mode = document.querySelector('[name=sp_mode]').value
	params.append('sp_mode',sp_mode)
	const response = await axios.post('/recept/search/pickup',params)
	if(response.data.result==='OK')
	{
		location.href = '/recept/search'
	}
}
window.receptSearchSet = async (id) =>{
	const params = new URLSearchParams()
	params.append('id',id)
	const response = await axios.post('/recept/search',params)
	if(response.data.result==='OK')
	{
		location.href = '/recept/edit/step1/'+id
	}
}

// edit/step1
window.receptStep1DlAndOpen = (fileId) => {
	mediaEdit(fileId)
}

window.receptStep1Activate = () => {
	cahngeStep1FormActive(true)
}

window.receptStep1Save = async () => {
	const params = new URLSearchParams()
	const regexDate = /^[0-9]{4}\/(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])$/
	const regexTime = /^([01][0-9]|2[0-3]):[0-5][0-9]-([01][0-9]|2[0-3]):[0-5][0-9]$/
	const programDate = document.querySelector('[name=program_date]').value
	const programTime = document.querySelector('[name=program_time]').value
	const performerName = document.querySelector('[name=performer_name]').value
	const validateDate = regexDate.test(programDate)
	if(!validateDate) document.getElementById('program_date_error').style.display = 'inline'
	const validateTime = regexTime.test(programTime)
	if(!validateTime) document.getElementById('program_time_error').style.display = 'inline'
	const validateName = performerName.split('　').length===2
	if(!validateName) document.getElementById('performer_name_error').style.display = 'inline'
	if(validateDate&&validateTime&&validateName)
	{
		/* ルーム名を取得 */
		const roomIndex = document.querySelector('[name=room_id]').selectedIndex
		const roomName = document.querySelector('[name=room_id]')[roomIndex].innerText
		/* 変更を検知 */
		let changed = false
		changed |= document.querySelector('[name=program_date]').value !== document.querySelector('[name=program_date_old]').value
		changed |= document.querySelector('[name=program_time]').value !== document.querySelector('[name=program_time_old]').value
		changed |= roomName !== document.querySelector('[name=room_name_old]').value
		changed |= document.querySelector('[name=program_no]').value !== document.querySelector('[name=program_no_old]').value
		changed |= document.querySelector('[name=program_title]').value !== document.querySelector('[name=program_title_old]').value
		changed |= document.querySelector('[name=performer_name]').value !== document.querySelector('[name=performer_name_old]').value
		changed |= document.querySelector('[name=seminar_name]').value !== document.querySelector('[name=seminar_name_old]').value

		let changedMemo = document.querySelector('[name=reception_memo]').value !== document.querySelector('[name=reception_memo_old]').value
		
		
		if(changed||changedMemo) {
			params.append('program_date',document.querySelector('[name=program_date]').value)
			params.append('program_time',document.querySelector('[name=program_time]').value)
			params.append('room_id',document.querySelector('[name=room_id]').value)
			params.append('program_no',document.querySelector('[name=program_no]').value)
			params.append('program_title',document.querySelector('[name=program_title]').value)
			params.append('performer_name',document.querySelector('[name=performer_name]').value)
			params.append('reception_memo',document.querySelector('[name=reception_memo]').value)
			params.append('seminar_name',document.querySelector('[name=seminar_name]').value)
			params.append('seminar_name_old',document.querySelector('[name=seminar_name_old]').value)
			const response = await axios.post('/recept/edit/step1',params)
			
			if(response.data.result==='OK')
			{
				alert('更新しました。')
				cahngeStep1FormActive(false)
				if(changed)
				{
					receptStep1Print()
				}
				/* 前回値を更新 */
				document.querySelector('[name=program_date_old]').value = document.querySelector('[name=program_date]').value
				document.querySelector('[name=program_time_old]').value = document.querySelector('[name=program_time]').value
				document.querySelector('[name=room_name_old]').value = roomName
				document.querySelector('[name=program_no_old]').value = document.querySelector('[name=program_no]').value
				document.querySelector('[name=program_title_old]').value = document.querySelector('[name=program_title]').value
				document.querySelector('[name=performer_name_old]').value = document.querySelector('[name=performer_name]').value
				document.querySelector('[name=reception_memo_old]').value = document.querySelector('[name=reception_memo]').value
				document.querySelector('[name=seminar_name_old]').value = document.querySelector('[name=seminar_name]').value
			}
		}
		else
		{
			cahngeStep1FormActive(false)
		}
	}
}

const receptPrintB = async () => {
	const params = new URLSearchParams()
	const pgm_subject_id = document.getElementById('t_pgm_subject_id').value
	params.append('t_pgm_subject_id', pgm_subject_id)
	params.append('program_date', document.querySelector('[name=program_date_old]').value)
	params.append('program_time', document.querySelector('[name=program_time_old]').value)
	params.append('room_name', document.querySelector('[name=room_name_old]').value)
	params.append('program_no', document.querySelector('[name=program_no_old]').value)
	params.append('program_title', document.querySelector('[name=program_title_old]').value)
	params.append('performer_name', document.querySelector('[name=performer_name_old]').value)
	printB(pgm_subject_id, params)
}

window.receptStep1Print = async () => {
	receptPrintB()
}

const cahngeStep1FormActive = (active) => {
	document.querySelector('[name=program_date]').readonly = true;
	document.querySelector('[name=program_time]').readonly = true;
	document.querySelector('[name=program_title]').disabled = !active
	if (window.is_performer_name) {
		document.querySelector('[name=performer_name]').disabled = !active
	} else {
		document.querySelector('[name=performer_name]').disabled = true;
	}
	if (window.is_seminar_name_editable) {
		document.querySelector('[name=program_no]').disabled = !active
	} else {
		document.querySelector('[name=program_no]').disabled = true
	}
	document.getElementById('go_step2').style.display = active?'none':'block'
	document.getElementById('edit_message').style.display = active?'none':'inline-block'
	document.getElementById('activate_btn').style.display = active?'none':'inline-block'
	document.getElementById('save_btn').style.display = active?'inline-block':'none'
	document.getElementById('program_date_error').style.display = 'none'
	document.getElementById('program_time_error').style.display = 'none'
	document.getElementById('performer_name_error').style.display = 'none'

	document.querySelector('[name=room_id]').disabled = true
	document.querySelector('[name=seminar_name]').disabled = true;
	document.querySelector('[name=reception_memo]').disabled = true

}

// edit/step2
window.receptStep2Initial = () => {
	step2CheckStatus()
}
window.receptStep2Save = async () => {
    const params = new URLSearchParams()
    params.append('device',document.querySelector('#type_form [name=device_type]').value)
    params.append('movie_flg',document.querySelector('#type_form [name=movie_flg]').value)
    params.append('sound_flg',document.querySelector('#type_form [name=sound_flg]').value)
    params.append('app_id',document.querySelector('#type_form [name=app_id]').value)
	const response = await axios.post('/recept/edit/step2',params)
	if(response.data.result==='OK')
	{
		location.href = '/recept/edit/step3'
	}
}
window.receptStep2ChangeDevice = (type) => {
	switch(type)
	{
		case 'removable':
			document.querySelector('[name=device_type]').value = 'removable'
			document.getElementById('application_list').innerHTML = document.getElementById('upload_select').innerHTML
			break
		case 'cdrom':
			document.querySelector('[name=device_type]').value = 'cdrom'
			document.getElementById('application_list').innerHTML = document.getElementById('upload_select').innerHTML
			break
		case 'ssd':
			document.querySelector('[name=device_type]').value = 'ssd'
			document.getElementById('application_list').innerHTML = document.getElementById('upload_select').innerHTML
			break
		case 'pc':
			document.querySelector('[name=device_type]').value = 'pc'
			document.getElementById('application_list').innerHTML = document.getElementById('pc_select').innerHTML
			break
		default:
			break
	}
}
const step2CheckStatus = () => {
	const movieFlg = document.querySelector('#type_form [name=movie_flg]').value
	const soundFlg = document.querySelector('#type_form [name=sound_flg]').value
	const appId = document.querySelector('#type_form [name=app_id]').value
	if(movieFlg!==''&&soundFlg!==''&&appId!=='')
	{
		document.getElementById('next_link').disabled = false
		document.getElementById('next_link').classList.add('btn-primary')
		document.getElementById('next_link').classList.remove('btn-secondary')
	}
	else
	{
		document.getElementById('next_link').disabled = true
		document.getElementById('next_link').classList.add('btn-secondary')
		document.getElementById('next_link').classList.remove('btn-primary')
	}
}
window.receptStep2ChangeMovie = (val) => {
	document.querySelector('#type_form [name=movie_flg]').value = val
	step2CheckStatus()
}
window.receptStep2ChangeSound = (val) => {
	document.querySelector('#type_form [name=sound_flg]').value = val
	step2CheckStatus()
}
window.receptStep2ChangeApp = () => {
	document.querySelector('#type_form [name=app_id]').value = document.getElementById('application_list').value
	if(document.getElementById('application_list').value==="0")
	{
		document.querySelector('#type_form [name=app_id]').value = ''
	}
	step2CheckStatus()
}

const checkDrive = () => {
	const deviceType = document.getElementById('device_type').value
	if(document.getElementById('check_enable').value==='1')
	{
		getDrives(deviceType,()=>setTimeout(checkDrive,1000))
	}
}

const dropZoneDragover = (e) => {
	const dropArea = document.getElementById('drop_area')
	e.stopPropagation()
	e.preventDefault()
	dropArea.style.background = '#e1e7f0'
}
const dropZoneDragleave = (e) => {
	const dropArea = document.getElementById('drop_area')
	e.stopPropagation()
	e.preventDefault()
	dropArea.style.background = '#ffffff';
}
const dropZoneDrop = (e) => {
	const dropArea = document.getElementById('drop_area')
	const formFiles = document.getElementById('files')
	const fileList = document.getElementById('file_list')
	e.stopPropagation()
	e.preventDefault()
	dropArea.style.background = '#ffffff'
	const files = e.dataTransfer.files
	formFiles.files = files
	while(fileList.lastChild){
		fileList.removeChild(fileList.lastChild);
	}
	for(var file of files) {
		const item = document.createElement('li')
		item.innerText = file.name
		fileList.append(item)
	}
	document.getElementById('start_upload').disabled = false
	document.getElementById('start_copy').disabled = false
}

// edit/step3
window.receptStep3Initial = () => {
	const dropZone = document.getElementById('drop_zone')
	const formFiles = document.getElementById('files')
	const fileList = document.getElementById('file_list')
	formFiles.value = ''
	const item = document.createElement('li')
	item.innerText = 'ここにドラッグしてください'
	while(fileList.lastChild){
		fileList.removeChild(fileList.lastChild);
	}
	fileList.append(item)
	dropZone.removeEventListener('dragover', dropZoneDragover)
	dropZone.removeEventListener('dragleave', dropZoneDragleave)
	dropZone.removeEventListener('drop', dropZoneDrop)
	dropZone.addEventListener('dragover', dropZoneDragover, false)
	dropZone.addEventListener('dragleave', dropZoneDragleave, false)
	dropZone.addEventListener('drop', dropZoneDrop, false)
	document.getElementById('start_upload').disabled = true
	document.getElementById('start_copy').disabled = true
	document.getElementById('step3').style.display = 'block';
	document.getElementById('step4').style.display = 'none';
	document.getElementById('check_enable').value = '1'
	setTimeout(checkDrive,1000)
}
window.receptStep3Save = async () => {
	const formFiles = document.getElementById('files')
	const formData = new FormData()
	for (let i = 0; i < formFiles.files.length; i++) {
		formData.append('file'+i, formFiles.files[i])
	}
	const config = {
		headers: {
			'content-type': 'multipart/form-data'
		},
		onUploadProgress:step3Progress,
	}
	document.getElementById('step3').style.display = 'none';
	document.getElementById('step4').style.display = 'block';
	//document.getElementById('uploadModal').classList.add('on')
	document.getElementById('check_enable').value = '0'
	const response = await axios.post('/recept/edit/step3',formData,config)
	console.log(response)
	if(response.data.result==='OK')
	{
		//location.href = '/recept/edit/step5'
		const tPgmSubjectId = document.getElementById('t_pgm_subject_id').value
		const callback = () => { location.href = '/recept/edit/step5' }
		mediaDownloads(tPgmSubjectId, callback, callback)
	}
}

window.receptStep3Copy = async () => {
	var tPgmSubjectId = document.getElementById('t_pgm_subject_id').value
	document.getElementById('step3').style.display = 'none';
	document.getElementById('step4').style.display = 'block';
	document.getElementById('check_enable').value = '0'
	const files = document.getElementById('files').files
	let filenames = []
	for(let index=0;index<files.length;index++) {
		filenames.push(files[index].name)
	}
	const params = new URLSearchParams()
	params.append('filenames',filenames.join(','))
	// 不要な場合以下の一行のみ削除で保存時までDB書き込みしない
	const response = await axios.post('/recept/edit/step3filenames',params)
	//const callback = () => { location.href = '/recept/edit/step5' }
	const callback = () => { receptStep3SaveFileName() }
	mediaCopy(tPgmSubjectId, files, step3Progress,callback)
}

window.receptStep3SaveFileName = async () => {
	const files = document.getElementById('files').files
	const filenames = []
	for(let file of files) {
		filenames.push(file.name)
	}
	const params = new URLSearchParams()
	params.append('files',filenames.join(','))
	const response = await axios.post('/recept/edit/step3files',params)
	//const deviceType = document.getElementById('device_type').value
	//removeDrive(()=>{ location.href = '/recept/edit/step5' })
	location.href = '/recept/edit/step5'
}

const step3Progress = (e,step=0,total=1) => {
	const progress = (e.loaded/e.total*100/total+100*step/total).toFixed(1)
	document.getElementById('progress_bar').style.width = ''+progress+'%'
	document.getElementById('progress_text').innerHTML = ''+progress+'%'
	//document.getElementById('uploadRatio').innerText = progress;
	//document.getElementById('uploadBar').style.width = progress + '%';
}

window.receptStep5Initial = (id) => {
//	mediaCheckDirectory(id)
}

window.receptStep5Save = async (id,deviceType) => {
	location.href='/recept/edit/step6';
/*
	removeDrive()
	setTimeout(()=>{location.href='/recept/edit/step6'},1000)
	document.getElementById('uploadModal').classList.add('on')
	//mediaRewrite(id, async () => {
	//排他処理
	mediaRewriteExclusive(id, async () => {
		const params = new URLSearchParams()
		const response = await axios.post('/recept/edit/step5',params)
		if(response.data.result==='OK')
		{
			removeDrive(deviceType)
			setTimeout(()=>{location.href='/recept/edit/step6'},1000)
		}
	})
*/
}

window.receptStep5RemoveDevice = async (id,deviceType) => {
	removeDrive(()=>{
		$('#step5-remove').css('display','none');
		$('#step5-next').css('display','inline-block');
		$('#open_opration').css('display','block');
	})
}

window.receptStep5OpenFiles = (id) => {
	mediaOpenCopiedFiles(id)
	axios.get('/recept/edit/printed/reset')
}

window.receptStep5OpenDirectory = (id) => {
	mediaOpenCopiedDirectory(id)
	axios.get('/recept/edit/printed/reset')
}

window.receptStep6Initial = async (id, device) => {
	//const printed = document.getElementById('printed').value
	const response = await axios.get('/recept/edit/printed/get')
	//console.log(response.data)
	if(response.data.printed==='0')
	{
		const params = new URLSearchParams()
		const filenames = document.getElementById('filenames').value
		params.append('origin_filenames', filenames)
		printA(id, params, device)
	}
}

window.receptStep7Activate = () => {
	$('.alert').addClass('d-none');
	cahngeStep7FormActive(true)
}

window.receptStep7Save = async () => {
	const params = new URLSearchParams()
	const regexDate = /^[0-9]{4}\/(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])$/
	const regexTime = /^([01][0-9]|2[0-3]):[0-5][0-9]-([01][0-9]|2[0-3]):[0-5][0-9]$/
	const receptionTimes = document.querySelector('[name=reception_times]').value
	const programDate = document.querySelector('[name=program_date]').value
	const programTime = document.querySelector('[name=program_time]').value
	const performerName = document.querySelector('[name=performer_name]').value
	const m_staff_choice_id = document.querySelector('[name=m_staff_choice_id]').value

	const validateTimes = !isNaN(receptionTimes)
	if(!validateTimes) document.getElementById('reception_times_error').style.display = 'inline'
	const validateDate = regexDate.test(programDate)
	if(!validateDate) document.getElementById('program_date_error').style.display = 'inline'
	const validateTime = regexTime.test(programTime)
	if(!validateTime) document.getElementById('program_time_error').style.display = 'inline'
	const validateName = performerName.split('　').length===2
	if(!validateName) document.getElementById('performer_name_error').style.display = 'inline'
	if (!m_staff_choice_id) document.getElementById('m_staff_choice_id_error').style.display = 'inline'
	if(validateTimes&&validateDate&&validateTime&&validateName&&m_staff_choice_id)
	{
		/* ルーム名を取得 */
		const roomIndex = document.querySelector('[name=room_id]').selectedIndex
		const roomName = document.querySelector('[name=room_id]')[roomIndex].innerText
		/* 変更を検知 */
		let changed = false
		changed |= document.querySelector('[name=program_date]').value !== document.querySelector('[name=program_date_old]').value
		changed |= document.querySelector('[name=program_time]').value !== document.querySelector('[name=program_time_old]').value
		changed |= roomName !== document.querySelector('[name=room_name_old]').value
		changed |= document.querySelector('[name=program_no]').value !== document.querySelector('[name=program_no_old]').value
		changed |= document.querySelector('[name=program_title]').value !== document.querySelector('[name=program_title_old]').value
		changed |= document.querySelector('[name=performer_name]').value !== document.querySelector('[name=performer_name_old]').value
		changed |= document.querySelector('[name=reception_times]').value !== document.querySelector('[name=reception_times_old]').value
		changed |= document.querySelector('[name=device]').value !== document.querySelector('[name=device_old]').value
		changed |= document.querySelector('[name=movie_flg]').value !== document.querySelector('[name=movie_flg_old]').value
		changed |= document.querySelector('[name=sound_flg]').value !== document.querySelector('[name=sound_flg_old]').value
		changed |= document.querySelector('[name=application_id]').value !== document.querySelector('[name=application_id_old]').value
		changed |= document.querySelector('[name=reception_memo]').value !== document.querySelector('[name=reception_memo_old]').value

		changed |= document.querySelector('[name=memo_text]').value != '';
		changed |= document.querySelector('[name=coi_file_flg]:checked').value !== document.querySelector('[name=coi_file_flg_old]').value
		changed |= document.querySelector('[name=seminar_name]').value != document.querySelector('[name=seminar_name_old]').value;
		if(changed) {
			params.append('reception_times',document.querySelector('[name=reception_times]').value)
			params.append('program_date',document.querySelector('[name=program_date]').value)
			params.append('program_time',document.querySelector('[name=program_time]').value)
			params.append('room_id',document.querySelector('[name=room_id]').value)
			params.append('program_no',document.querySelector('[name=program_no]').value)
			params.append('program_title',document.querySelector('[name=program_title]').value)
			params.append('performer_name',document.querySelector('[name=performer_name]').value)
			params.append('device',document.querySelector('[name=device]').value)
			params.append('movie_flg',document.querySelector('[name=movie_flg]').value)
			params.append('sound_flg',document.querySelector('[name=sound_flg]').value)
			params.append('application_id',document.querySelector('[name=application_id]').value)
			params.append('reception_memo',document.querySelector('[name=reception_memo]').value)
			params.append('memo_text',document.querySelector('[name=memo_text]').value)
			params.append('seminar_name',document.querySelector('[name=seminar_name]').value)
			params.append('seminar_name_old',document.querySelector('[name=seminar_name_old]').value)
			params.append('coi_file_flg',document.querySelector('[name=coi_file_flg]:checked').value)
			params.append('m_staff_choice_id',document.querySelector('[name=m_staff_choice_id]').value)
			const response = await axios.post('/recept/edit/step7',params)
			if(response.data.result==='OK')
			{
				if (document.querySelector('[name=memo_text]').value != '') {
					location.reload();
				} else {
					alert('更新しました。')
					//receptPrintB()
					cahngeStep7FormActive(false)
	
					document.querySelector('[name=program_date_old]').value = document.querySelector('[name=program_date]').value
					document.querySelector('[name=program_time_old]').value = document.querySelector('[name=program_time]').value
					document.querySelector('[name=room_name_old]').value = roomName
					document.querySelector('[name=program_no_old]').value = document.querySelector('[name=program_no]').value
					document.querySelector('[name=program_title_old]').value = document.querySelector('[name=program_title]').value
					document.querySelector('[name=performer_name_old]').value = document.querySelector('[name=performer_name]').value
					document.querySelector('[name=reception_times_old]').value = document.querySelector('[name=reception_times]').value
					document.querySelector('[name=device_old]').value = document.querySelector('[name=device]').value
					document.querySelector('[name=movie_flg_old]').value = document.querySelector('[name=movie_flg]').value
					document.querySelector('[name=sound_flg_old]').value = document.querySelector('[name=sound_flg]').value
					document.querySelector('[name=application_id_old]').value = document.querySelector('[name=application_id]').value
					document.querySelector('[name=reception_memo_old]').value = document.querySelector('[name=reception_memo]').value
					document.querySelector('[name=seminar_name_old]').value = document.querySelector('[name=seminar_name]').value
					document.querySelector('[name=coi_file_flg_old]').value = document.querySelector('[name=coi_file_flg]:checked').value
				}
			}
		} else {
			cahngeStep7FormActive(false)
		}
	}
}

const cahngeStep7FormActive = (active) => {

	document.querySelector('[name=reception_times]').readonly = true
	document.querySelector('[name=program_date]').readonly = true
	document.querySelector('[name=program_time]').readonly = true
	/* 2022/08/09 変更分 begin */
	document.querySelector('[name=program_no]').disabled = true
	document.querySelector('[name=program_title]').disabled = true
	document.querySelector('[name=performer_name]').disabled = true
	/*
	document.querySelector('[name=program_no]').disabled = !active
	document.querySelector('[name=program_title]').disabled = !active
	if (window.is_performer_name) {
		document.querySelector('[name=performer_name]').disabled = !active
	} else {
		document.querySelector('[name=performer_name]').disabled = true
	}
	*/
	/* 2022/08/09 変更分 end */
	document.querySelector('[name=device]').disabled = !active
	document.querySelector('[name=movie_flg]').disabled = !active
	document.querySelector('[name=sound_flg]').disabled = !active
	document.querySelector('[name=application_id]').disabled = !active
	document.querySelector('[name=memo_text]').disabled = !active

	
	document.querySelectorAll('[name=coi_file_flg]')[0].disabled = !active
	document.querySelectorAll('[name=coi_file_flg]')[1].disabled = !active

	document.getElementById('activate_btn').style.display = active?'none':'inline-block'
	document.getElementById('save_btn').style.display = active?'inline-block':'none'
	document.getElementById('reception_times_error').style.display = 'none'
	document.getElementById('program_date_error').style.display = 'none'
	document.getElementById('program_time_error').style.display = 'none'
	document.getElementById('performer_name_error').style.display = 'none'
	document.getElementById('m_staff_choice_id_error').style.display = 'none'
	document.getElementById('finish_area').style.display = active?'none':'block'
	document.getElementById('message_area').style.display = active?'none':'block'

	document.querySelector('[name=room_id]').disabled = true
	document.querySelector('[name=seminar_name]').disabled = true;
	document.querySelector('[name=reception_memo]').disabled = true
	
}

window.receptStep7Fin =  async (id) => {
	const isPC = document.querySelector('[name=device]').value==='pc'
	//mediaRewrite(id, async () => {
	//排他処理
	$('.alert').addClass('d-none');
	const paramsForValidation = new URLSearchParams()
	paramsForValidation.append('m_staff_choice_id',document.querySelector('[name=m_staff_choice_id]').value)
	const responseValidation = await axios.post('/recept/edit/step7FinishedValidation',paramsForValidation);
	if (responseValidation.data.result == "OK") {
		if(isPC) {
			const params = new URLSearchParams()
			params.append('m_staff_choice_id',document.querySelector('[name=m_staff_choice_id]').value)
			const response = await axios.post('/recept/edit/step7finished',params)
			location.href = '/recept/edit/step8'
		} else {
			document.getElementById('uploadModal').classList.add('on')
			const params = new URLSearchParams()
			params.append('saved_path',document.getElementById('saved_path').value)
			mediaRewriteExclusive(id, params, async () => {
				params.append('m_staff_choice_id',document.querySelector('[name=m_staff_choice_id]').value)
				const response = await axios.post('/recept/edit/step7finished',params)
				if(response.data.result==='OK')
				{
					mediaAppLinks(id,()=>{
						location.href = '/recept/edit/step8'
					})
				}
			}, async () => {
				let language = $('.navbar-lang_nav .active').text();
				if (language == "Japanese") {
					alert('ファイルアップロードに失敗しました。再度アップロードしてください。')
				} else {
					alert('The file upload failed. Please try uploading again.')
				}
				document.getElementById('uploadModal').classList.remove('on')
			})
		}
	} else if (responseValidation.data.result == 'VALIDATION_FAILED') {
		let error = '';
		Object.keys(responseValidation.data.validation_error).forEach(key => {
			responseValidation.data.validation_error[key].forEach(msg => {
				error += `<li>${msg}</li>`;
			})
		});
		$('.alert').removeClass('d-none').find('ul').empty('').append(error);
		window.scrollTo({
			top: 0,
			behavior: 'smooth' // To enable smooth scrolling
		});
	}
/*
	const response = await axios.get('/recept/edit/step7finished')
	if(response.data.result==='OK')
	{
		location.href = '/recept/edit/step8'
	}
*/
}

window.bfReceptionDownload = (e) => {
	var tPgmSubjectId = document.getElementById('t_pgm_subject_id').value
	if (tPgmSubjectId) {
		const callback = () => {location.href = '/recept/edit/step5?prerecept=1'}
		mediaReceptDownloads(tPgmSubjectId, callback, callback)	
	}
}
